import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { AppCard, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import BreadcrumbHandler from '../../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from '../../../../routing/helpers/router';
import ResourceManagerSidebar from '../../../../layout/screenSpecifics/Modules/ResourceManager/Sidebar/ResourceManagerSidebar';
import SettingsTabs from '../../../../layout/screenSpecifics/Modules/ResourceManager/Settings/SettingsTabs';
import colors from '../../../../constants/colors';
import ResourceTemplate from '../../../../layout/screenSpecifics/Modules/ResourceManager/Settings/ResourceTemplate/ResourceTemplate';
import Translator from '../../../../layout/components/helpers/Translator';
import * as moduleAction from '../../../../store/actions/moduleAction';

export default function ModuleResourceManagerSettingsResourceTemplateListScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const [templates, setTemplates] = useState();

  // PARA CAMBIAR A FUTURO A COMPONENTE O SIMILAR
    if (!moduleBridgeHex || !moduleData) {
      <AppNoInfo />;
    }
    // > LOAD MODULE DATA //
    const loadModuleData = useCallback(async () => {
      dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_resourceManager_getModuleData'),
          'moduleData',
          {
            moduleBridgeHex,
          },
        ),
      );
    }, []);
  
    useEffect(() => {
        !moduleData && loadModuleData();
      }, []);
    // > LOAD MODULE DATA //
    // < STORE CALLS
    const loadModulePermissions = useCallback(async () => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'permissions',
            {
              moduleBridgeHex,
              subType: 'permissions',
            },
          ),
        );
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'userBridge',
            {
              moduleBridgeHex,
              subType: 'userBridge',
            },
          ),
        );
      } catch (err) {}
    }, [moduleBridgeHex]);
  
    useEffect(() => {
      loadModulePermissions();
    }, [moduleBridgeHex]);
    // < STORE CALLS

  // > LOAD RESOURCE TEMPLATES
  const loadResourceTemplates = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_resourceManager_settings_resourceTemplate_list"
          ),
          {
            moduleBridgeHex,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) setTemplates(data);
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex]
  );

  useEffect(() => {
    loadResourceTemplates();
  }, []);
  // < LOAD RESOURCE TEMPLATES

  return (
    <>
      <ResourceManagerSidebar activeRoute="user_module_resourceManager_settings" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: `${moduleData?.moduleName}`,
                  route: {
                    name: 'user_module_resourceManager_resource_home',
                    params: { moduleBridgeHex },
                  },
                },
                {
                  name: ReactDOMServer.renderToString(
                    <Translator
                      file="module-resourceManager"
                      name="resource.settings"
                    />
                  ),
                },
              ]
            : [
                {
                  name: '...',
                },
              ]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          <SettingsTabs
            moduleBridgeHex={moduleBridgeHex}
            activeTab="resourceTemplates"
          />
          <AppCard>
            {templates?.filter((t) => !t?.fixed) !== undefined ? (
              <>
                {templates?.length > 0 ? (
                  <>
                    <h6>
                      <Translator
                        file="module-resourceManager"
                        name="own-templates"
                      />
                    </h6>
                    <table className="table table-hover table-sm">
                      <thead>
                        <tr>
                          <th className="col-4">
                            <Translator
                              file="module-resourceManager"
                              name="resource.template"
                            />
                          </th>
                          <th className="col-3">
                            <Translator
                              file="module-resourceManager"
                              name="resource.typology"
                            />
                          </th>
                          <th className="col-3">
                            <Translator
                              file="module-resourceManager"
                              name="resource.subtypology"
                            />
                          </th>
                          <th className="col-1">
                            <Translator
                              file="module-resourceManager"
                              name="resource.used"
                            />
                          </th>
                          <th className="col-1">
                            <Translator
                              file="module-resourceManager"
                              name="resource.options"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates
                          ?.filter((t) => !t?.fixed)
                          ?.map((template) => (
                            <ResourceTemplate
                              template={template}
                              key={template.hex}
                              loadResourceTemplates={loadResourceTemplates}
                            />
                          ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <AppNoInfo
                    text={
                      <Translator
                        file="module-resourceManager"
                        name="resource.no.custom.templates"
                      />
                    }
                    icon={
                      <AppRemixIcon
                        icon="file-unknow"
                        color={colors.grey500}
                        size={44}
                      />
                    }
                    minHeight={250}
                  />
                )}
                {templates?.filter((t) => t?.fixed)?.length > 0 ? (
                  <>
                    <h6 className="mt-5">
                      <Translator
                        file="module-resourceManager"
                        name="resource.base.templates"
                      />
                    </h6>
                    <table className="table table-hover table-sm">
                      <thead>
                        <tr>
                          <th className="col-4">
                            <Translator
                              file="module-resourceManager"
                              name="resource.template"
                            />
                          </th>
                          <th className="col-3">
                            <Translator
                              file="module-resourceManager"
                              name="resource.typology"
                            />
                          </th>
                          <th className="col-3">
                            <Translator
                              file="module-resourceManager"
                              name="resource.subtypology"
                            />
                          </th>
                          <th className="col-1">
                            <Translator
                              file="module-resourceManager"
                              name="resource.used"
                            />
                          </th>
                          <th className="col-1">
                            <Translator
                              file="module-resourceManager"
                              name="resource.options"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates
                          ?.filter((t) => t?.fixed)
                          ?.map((template) => (
                            <ResourceTemplate
                              template={template}
                              key={template.hex}
                              loadResourceTemplates={loadResourceTemplates}
                            />
                          ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <AppNoInfo
                    text={
                      <Translator
                        file="module-resourceManager"
                        name="resource.no.base.templates"
                      />
                    }
                    icon={
                      <AppRemixIcon
                        icon="file-unknow"
                        color={colors.grey500}
                        size={44}
                      />
                    }
                    minHeight={250}
                  />
                )}
              </>
            ) : (
              <AppNoInfo
                text={
                  <Translator
                    file="module-resourceManager"
                    name="resource.loading"
                  />
                }
                minHeight={250}
              />
            )}
          </AppCard>
        </div>
      </main>
    </>
  );
}
